import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Collapse from './bootstrap/Collapse';
import Icon from './icon/Icon';

const VerticalStepper = ({
	steps,
	currentStep,
	activeStep: initialActiveStep = null,
	allStepsExpanded = false,
}) => {
	const [expandedStep, setExpandedStep] = useState(
		initialActiveStep !== null ? initialActiveStep : currentStep,
	);
	const [expandAll, setExpandAll] = useState(allStepsExpanded);

	useEffect(() => {
		if (initialActiveStep !== null) {
			setExpandedStep(initialActiveStep);
		}
	}, [initialActiveStep]);

	useEffect(() => {
		setExpandAll(allStepsExpanded);
	}, [allStepsExpanded]);

	const handleStepClick = (index) => {
		if (!expandAll) {
			setExpandedStep(expandedStep === index ? null : index);
		}
	};
	return (
		<div className='vertical-stepper'>
			{steps.map((step, index) => {
				const isCompleted = currentStep > index;
				const isExpanded = expandAll || expandedStep === index;
				return (
					<div
						key={step.title}
						className={classNames('step', {
							active: isExpanded,
							current: currentStep === index,
							completed: isCompleted,
						})}
						onClick={() => handleStepClick(index)}
						onKeyDown={(e) => {
							if (e.key === 'Enter' || e.key === ' ') {
								handleStepClick(index);
							}
						}}
						role='button'
						tabIndex={0}>
						<span className='step-number'>{isCompleted ? '✓' : index + 1}</span>
						<div className='step-content'>
							<div className='step-title'>
								{step.title}
								{!expandAll && (
									<Icon
										icon={isExpanded ? 'ChevronUp' : 'ChevronDown'}
										className='step-chevron'
									/>
								)}
							</div>
							<Collapse isOpen={isExpanded}>{step.description}</Collapse>
						</div>
					</div>
				);
			})}
		</div>
	);
};

VerticalStepper.propTypes = {
	steps: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			description: PropTypes.node.isRequired,
		}),
	).isRequired,
	currentStep: PropTypes.number.isRequired,
	activeStep: PropTypes.number,
	allStepsExpanded: PropTypes.bool,
};

VerticalStepper.defaultProps = {
	activeStep: null,
	allStepsExpanded: false,
};

export default VerticalStepper;
